window.app = window.app || {};

window.app.productPage = {
  el: {
    section: document.querySelector('.mt-product'),
    title: document.querySelector('.mt-product__title'),
    mainPrices: document.querySelector('.mt-product__prices'),
    prices: document.querySelectorAll('.mt-product .mt-prices'),
    offer: {
      section: document.querySelectorAll('.mt-product .mt-form-offer'),
      checkbox: document.querySelectorAll('.mt-product .mt-form-offer__checkbox input')
    },
    thumbs: document.querySelector('.mt-product-thumbs .swiper'),
    thumbItems: document.querySelectorAll('.mt-product-thumbs .swiper-slide'),
    thumbButtons: document.querySelectorAll('.mt-product-thumbs__button'),
    mainGallery: document.querySelector('.mt-product-gallery .swiper'),
    staticGallery: document.querySelector('.mt-product-static-gallery'),
    accordions: document.querySelectorAll('.mt-product-details .mt-accordion'),
    accordionTabs: document.querySelectorAll('.mt-product-tabs__tab'),
    productForm: document.querySelector('.mt-product .mt-product-form'),
    productFormId: document.querySelector('.mt-product .mt-product-form input[name="id"]'),
    productFormBtn: document.querySelector('.mt-product .mt-product-form .mt-btn[type="submit"]'),
    stickyProductForm: document.querySelector('.mt-sticky-product-form'),
    stickyProductFormBtn: document.querySelector('.mt-sticky-product-form .mt-btn'),
    whatsInBundle: document.querySelector('.mt-whats-in-bundle'),
    bisSection: document.querySelector('.klaviyo-bis'),
    bisVariant: document.querySelector('.klaviyo-bis__fields input[name="variant"]'),
    customBtns: document.querySelectorAll('.mt-product-cta'),
    podsSelector: {
      form: document.querySelector('.mt-pods-selector'),
      formBtn: document.querySelector('.mt-pods-selector__action .mt-btn'),
      details: document.querySelector('.mt-pods__details'),
      detailsSummary: document.querySelector('.mt-pods-step--pods .mt-pods-step__summary-info'),
      options: document.querySelectorAll('.mt-pods__option input'),
      memberships: document.querySelectorAll('.mt-pods-membership'),
      membershipsToggle: document.querySelectorAll('.mt-pods-membership__toggle'),
      membershipsOption: document.querySelectorAll('.mt-pods-membership__checkbox input'),
      accessories: document.querySelector('.mt-accessories'),
      accessoriesItems: document.querySelectorAll('.mt-accessories__item'),
      courses: document.querySelector('.mt-courses'),
      coursesItems: document.querySelectorAll('.mt-courses__item'),
      step: {
        all: document.querySelectorAll('.mt-pods-step'),
        pods: document.querySelector('.mt-pods-step--pods'),
        memberships: document.querySelector('.mt-pods-step--membership'),
        accessories: document.querySelector('.mt-pods-step--accessories'),
        courses: document.querySelector('.mt-pods-step--courses'),
      },
      btn: {
        pods: document.querySelector('.mt-pods .mt-pods-step__summary .mt-btn'),
        memberships: document.querySelector('.mt-pods-memberships .mt-pods-step__summary .mt-btn')
      }
    },
    variantSelector: {
      options: document.querySelectorAll('.mt-product-option__list input')
    },
    reviewsSummary: document.querySelector('.mt-product__reviews button.mt-rating'),
  },
  slider: {},

  updatePrice: function () {
    const _this = this;
    const withDecimals = window.Shopify.money_format;
    if (!_this.el.mainPrices || _this.el.mainPrices.dataset.price === undefined) return;

    let price = _this.el.mainPrices.dataset.price;
    let compareAtPrice = (_this.el.mainPrices.dataset.compareAtPrice !== undefined) ? _this.el.mainPrices.dataset.compareAtPrice : null;
    let formattedPrice = Shopify.formatMoney(_this.el.mainPrices.dataset.price, withDecimals).replace('.00', '');
    let formattedCAP = (_this.el.mainPrices.dataset.compareAtPrice !== undefined) ? Shopify.formatMoney(_this.el.mainPrices.dataset.compareAtPrice, withDecimals).replace('.00', '') : null;
    let pricesHtml = '';

    // Default price
    if (compareAtPrice !== null) {
      pricesHtml = `<span class="mt-price mt-price--sale">${formattedPrice}</span><s class="mt-price mt-price--old">${formattedCAP}</s>`;
    } else {
      pricesHtml = `<span class="mt-price">${formattedPrice}</span>`;
    }

    // With offer/s
    if (_this.el.offer.section.length > 0 && _this.el.offer.checkbox.length > 0) {
      let anyOfferActive = false;
      let totalPrice = Number(_this.el.mainPrices.dataset.price);
      let totalCompareAtPrice = Number(_this.el.mainPrices.dataset.compareAtPrice) || totalPrice;

      _this.el.offer.section.forEach(offerSection => {
        const offerCheckbox = offerSection.querySelector('.mt-form-offer__checkbox input');
        if (offerSection.dataset.offerActive == 'true') {
          totalPrice += Number(offerCheckbox.dataset.price);
          totalCompareAtPrice += Number(offerCheckbox.dataset.compareAtPrice || offerCheckbox.dataset.price);
          anyOfferActive = true;
        }
      });

      if (anyOfferActive) {
        price = totalPrice;
        compareAtPrice = totalCompareAtPrice;
        formattedPrice = Shopify.formatMoney(totalPrice, withDecimals).replace('.00', '');
        formattedCAP = Shopify.formatMoney(totalCompareAtPrice, withDecimals).replace('.00', '');
  
        if (totalCompareAtPrice > totalPrice) {
          pricesHtml = `<span class="mt-price mt-price--sale">${formattedPrice}</span><s class="mt-price mt-price--old">${formattedCAP}</s>`;
        } else {
          pricesHtml = `<span class="mt-price">${formattedPrice}</span>`;
        }
      }
    }

    _this.el.mainPrices.dataset.totalPrice = price;
    _this.el.mainPrices.dataset.totalCompareAtPrice = compareAtPrice;
    _this.el.prices.forEach(priceEl => (priceEl.innerHTML = pricesHtml));
    app.productPage.updateAffirmPrice();
  },

  updateAffirmPrice: function () {
    const affirmEls = document.querySelectorAll('.affirm-as-low-as');
    const price = app.productPage.el.mainPrices.dataset.totalPrice;

    affirmEls.forEach(el => el.dataset.amount = price);
    if (typeof affirm === 'object') affirm?.ui?.refresh?.();

    setTimeout(() => {
      const updatedAffirmEls = document.querySelectorAll('.affirm-as-low-as');
      const isVisible = Array.from(updatedAffirmEls).some(el => el.innerText);
      if (!isVisible && typeof initializePromos === 'function') {
        if (typeof affirm === 'object') affirm?.ui?.refresh?.();
      }
    }, 500);
  },

  podsSelector: {
    currentStep: 1,

    form: function () {
      const _this = app.productPage;
      _this.el.podsSelector.form.addEventListener('submit', e => {
        e.preventDefault();

        const miniCart = document.querySelector('.mt-mini-cart');
        const formData = { items: [] };
        const items = [];
        const bundleId = `#${Math.random().toString(36).slice(2, 7)}`;
        const bundleIdQ = `#${Math.random().toString(36).slice(2, 7)}`;

        _this.el.podsSelector.formBtn.disabled = true;
        _this.el.podsSelector.formBtn.classList.add('mt-btn--loading');

        // Main product
        const mainProduct = document.querySelector('.mt-pods__option input:checked');
        if (mainProduct) {
          items.push({
            id: Number(mainProduct.value),
            quantity: 1
          });
        }

        // Additional membership
        const membership = document.querySelector('.mt-pods-membership__checkbox input:checked');
        if (membership && membership.value != 0) {
          items[0].properties = { _bundleId: bundleId, _itemType: 'product-main' };
          items.push({
            id: Number(membership.value),
            selling_plan: Number(membership.dataset.sellingPlan),
            quantity: 1,
            properties: {
              _bundleId: bundleId,
              _bundleIdQ: bundleIdQ,
              _itemEditable: false,
              _itemRemovable: true,
              _sellingPlan: Number(membership.dataset.sellingPlan)
            }
          });
        }

        // Additional products
        const otherProducts = document.querySelectorAll('.mt-accessories__item.active, .mt-courses__item.active');
        if (otherProducts.length > 0) {
          otherProducts.forEach(product => {
            const input = product.querySelector('.mt-quantity__input');
            const productData = {
              id: Number(input.dataset.variant),
              quantity: Number(input.value),
              properties: {
                _upsellFor: bundleId
              }
            };
            if (product.dataset.course == 'true') {
              items[0].properties = { _bundleId: bundleId, _itemType: 'product-main' };
              productData.properties = {
                ...productData.properties,
                _bundleId: bundleId,
                _bundleIdQ: bundleIdQ
              }
            }
            items.push(productData);
          });
        }

        // Add to cart
        formData.items = items.reverse();

        // Prepare DataLayer products
        const productsToAdd = [];
        if (mainProduct && mainProduct.dataset.product) productsToAdd.push(mainProduct.dataset.product);
        if (membership && membership.value != 0 && membership.dataset.product) productsToAdd.push(membership.dataset.product);
        otherProducts.forEach(el => {
          const input = el.querySelector('.mt-quantity__input');
          if (input && input.dataset.product) {
            const productData = JSON.parse(input.dataset.product);
            productData.quantity = Number(input.value);
            productsToAdd.push(JSON.stringify(productData));
          }
        });

        if (miniCart && window.innerWidth > 768) {
          formData.sections = 'mt-mini-cart';
          const addToCart = () => {
            app.cart.updateView(formData, 'add', () => {
              miniCart.classList.add('active');
              miniCart.setAttribute('aria-hidden', false);
              setTimeout(() => miniCart.classList.add('visible'), 50);
              if (_this.el.podsSelector.formBtn !== null) {
                _this.el.podsSelector.formBtn.disabled = false;
                _this.el.podsSelector.formBtn.classList.remove('mt-btn--loading');
              }

              app.dl.addedToCart(...productsToAdd);
            });
          };

          if (app.discounts.hasMembership(formData.items)) {
            app.discounts.apply(app.discounts.membershipDiscountCode, addToCart);
          } else {
            addToCart();
          }
        } else {
          const addToCart = () => {
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formData)
            })
              .then(response => response.json())
              .then(() => {
                if (_this.el.podsSelector.formBtn !== null) {
                  _this.el.podsSelector.formBtn.disabled = false;
                  _this.el.podsSelector.formBtn.classList.remove('mt-btn--loading');
                }

                app.dl.addedToCart(...productsToAdd);
                window.top.location = window.Shopify.routes.root + 'cart';
              })
              .catch((error) => {
                console.error('Error:', error);
                if (_this.el.podsSelector.formBtn !== null) {
                  _this.el.podsSelector.formBtn.disabled = false;
                  _this.el.podsSelector.formBtn.classList.remove('mt-btn--loading');
                }
                window.top.location.reload();
              });
          };

          if (app.discounts.hasMembership(formData.items)) {
            app.discounts.apply(app.discounts.membershipDiscountCode, addToCart);
          } else {
            addToCart();
          }
        }
      });
    },

    updateVariant: function () {
      const _this = app.productPage;
      _this.el.whatsInBundle = document.querySelector('.mt-whats-in-bundle');

      let productUrl = window.location.origin + window.location.pathname + window.location.search + (window.location.search ? `&sections=${_this.el.section.dataset.section}` : `?sections=${_this.el.section.dataset.section}`);
      _this.el.whatsInBundle && (productUrl += `,${_this.el.whatsInBundle.dataset.section}`);

      _this.el.podsSelector.details.classList.add('loading');

      fetch(productUrl)
        .then(res => res.json())
        .then(res => {
          const productSection = document.createElement('div');
          productSection.innerHTML = res[_this.el.section.dataset.section];
          _this.el.whatsInBundle && (productSection.innerHTML += res[_this.el.whatsInBundle.dataset.section]);

          const sections = {
            prices: productSection.querySelector('.mt-product__prices'),
            details: productSection.querySelector('.mt-pods__details'),
            detailsSummary: productSection.querySelector('.mt-pods-step--pods .mt-pods-step__summary-info'),
            staticGallery: productSection.querySelector('.mt-product-static-gallery'),
            whatsInBundle: productSection.querySelector('.mt-whats-in-bundle')
          };

          // Update view
          _this.el.staticGallery.innerHTML = sections.staticGallery.innerHTML;
          _this.el.podsSelector.details.innerHTML = sections.details.innerHTML;
          _this.el.podsSelector.detailsSummary.innerHTML = sections.detailsSummary.innerHTML;
          if (_this.el.whatsInBundle) {
            if (sections.whatsInBundle) {
              _this.el.whatsInBundle.innerHTML = sections.whatsInBundle.innerHTML;
              _this.el.whatsInBundle.classList.remove('hidden');
              app.productInBundle.init();
            } else {
              _this.el.whatsInBundle.classList.add('hidden');
            }
          }

          // Update price
          _this.el.mainPrices.dataset.price = sections.prices.dataset.price;
          _this.el.mainPrices.dataset.compareAtPrice = sections.prices.dataset.compareAtPrice;
          _this.podsSelector.updatePrice();

          _this.el.podsSelector.details.classList.remove('loading');
        });
    },

    updatePrice: function () {
      const _this = app.productPage;
      const withDecimals = window.Shopify.money_format;
      let pricesHtml = '';
      let price = Number(_this.el.mainPrices.dataset.price);
      let compareAtPrice = (_this.el.mainPrices.dataset.compareAtPrice != 'undefined') ? Number(_this.el.mainPrices.dataset.compareAtPrice) : price;

      // Membership
      _this.el.podsSelector.membershipsOption.forEach(option => {
        if (option.checked && option.dataset.price) {
          price += Number(option.dataset.price);
          compareAtPrice += option.dataset.compareAtPrice ? Number(option.dataset.compareAtPrice) : Number(option.dataset.price);
        }
      });

      // Accessories & Courses
      [..._this.el.podsSelector.accessoriesItems, ..._this.el.podsSelector.coursesItems].forEach(item => {
        if (item.classList.contains('active')) {
          const itemQuantityEl = item.querySelector('.mt-quantity__input');
          const itemQuantity = Number(itemQuantityEl.value);
          price += (Number(itemQuantityEl.dataset.price) * itemQuantity);
          compareAtPrice += itemQuantityEl.dataset.compareAtPrice ? (Number(itemQuantityEl.dataset.compareAtPrice) * itemQuantity) : (Number(itemQuantityEl.dataset.price) * itemQuantity);
        }
      });
      
      // Price rounding
      if (_this.el.podsSelector.form.dataset.priceRounding == 'true') {
        price = (price > 100) ? (Math.ceil(price / 100) * 100) : price;
        compareAtPrice = (compareAtPrice > 100) ? (Math.ceil(compareAtPrice / 100) * 100) : compareAtPrice;
      }

      // Update view
      if (compareAtPrice > price) {
        pricesHtml = `<span class="mt-price mt-price--sale">${Shopify.formatMoney(price, withDecimals).replace('.00', '')}</span><s class="mt-price mt-price--old">${Shopify.formatMoney(compareAtPrice, withDecimals).replace('.00', '')}</s>`;
      } else {
        pricesHtml = `<span class="mt-price">${Shopify.formatMoney(price, withDecimals).replace('.00', '')}</span>`;
      }
      _this.el.mainPrices.dataset.totalPrice = price;
      _this.el.mainPrices.dataset.totalCompareAtPrice = compareAtPrice;
      _this.el.prices.forEach(priceEl => (priceEl.innerHTML = pricesHtml));
      app.productPage.updateAffirmPrice();
    },

    init: function () {
      const _this = app.productPage;
      if (!_this.el.podsSelector.form) return;

      // Pods
      _this.el.podsSelector.options.forEach(option => {
        option.addEventListener('change', () => {
          const choose = _this.el.podsSelector.step.pods.querySelector('.mt-pods-step__choose span');
          choose.innerHTML = option.dataset.title;
          if (history.replaceState) {
            const currentUrl = new URL(window.top.location.href);
            const searchParams = currentUrl.searchParams;
            searchParams.set('variant', option.value);
            currentUrl.search = searchParams.toString();
            history.replaceState({}, null, currentUrl.toString());
            _this.podsSelector.updateVariant();
          }
        });
      });

      // Toggle membership details
      _this.el.podsSelector.membershipsToggle.forEach(el => {
        const plan = el.closest('.mt-pods-membership');
        el.addEventListener('click', e => {
          e.preventDefault();
          _this.el.podsSelector.memberships.forEach(memb => memb !== plan && memb.classList.remove('active'));
          plan.classList.toggle('active');
        });
      });

      // Membership options
      _this.el.podsSelector.membershipsOption.forEach(option => {
        option.addEventListener('change', () => {
          const membership = option.closest('.mt-pods-membership');
          const choose = _this.el.podsSelector.step.memberships.querySelector('.mt-pods-step__choose span');
          choose.innerHTML = option.dataset.title;
          _this.el.podsSelector.btn.memberships.disabled = false;
          _this.el.podsSelector.memberships.forEach(el => (el === membership) ? el.classList.add('mt-pods-membership--selected') : el.classList.remove('mt-pods-membership--selected'));
          _this.podsSelector.updatePrice();
        });
      });

      // Accessories
      if (_this.el.podsSelector.accessories && _this.el.podsSelector.accessoriesItems.length > 0) {
        _this.el.podsSelector.accessoriesItems.forEach(item => {
          const itemImage = item.querySelector('.mt-accessories__item-image');
          const itemQuantity = item.querySelector('.mt-quantity__input');
          const itemDesc = {
            el: item.querySelector('.mt-accessories__item-description'),
            primary: item.querySelector('.mt-accessories__item-description-primary'),
            secondary: item.querySelector('.mt-accessories__item-description-secondary')
          };
          item.addEventListener('click', e => {
            if (e.target.classList.contains('mt-quantity') || e.target.closest('.mt-quantity')) return;
            if (item.classList.contains('active')) {
              item.classList.remove('active');
              itemImage.removeAttribute('data-quantity');
            } else {
              item.classList.add('active');
              (Number(itemQuantity.value) > 1) && itemImage.setAttribute('data-quantity', `x${itemQuantity.value}`);
            }

            const activeProducts = document.querySelectorAll('.mt-accessories__item.active').length;
            const choose = _this.el.podsSelector.step.accessories.querySelector('.mt-pods-step__choose span');
            if (activeProducts > 0) {
              _this.el.podsSelector.step.accessories.classList.add('completed');
              choose.innerHTML = `${activeProducts} ${(activeProducts > 1) ? 'Accessories' : 'Accessory'}`;
            } else {
              _this.el.podsSelector.step.accessories.classList.remove('completed');
              choose.innerHTML = '';
            }
            _this.podsSelector.updatePrice();
          });
          itemQuantity.addEventListener('change', () => {
            const quantity = Number(itemQuantity.value);
            if (quantity == 0) {
              itemImage.removeAttribute('data-quantity');
              item.classList.remove('active');
              itemQuantity.value = 1;
            } else if (quantity > 1) {
              itemImage.setAttribute('data-quantity', `x${quantity}`);
            } else {
              itemImage.removeAttribute('data-quantity');
            }
            _this.podsSelector.updatePrice();
          });

          // Update description element
          const updateItemDescription = () => {
            if (itemDesc.primary || itemDesc.secondary) {
              let itemDescType = 'list';
              let itemHeight = 0;
              if (itemDesc.primary) {
                itemDescType = 'list';
                itemHeight = itemDesc.primary.offsetHeight;
              }
              if (itemDesc.secondary && itemDesc.secondary.offsetHeight > itemHeight) {
                itemDescType = 'text';
                itemHeight = itemDesc.secondary.offsetHeight;
              }

              itemDesc.el.classList.remove('mt-accessories__item-description--list');
              itemDesc.el.classList.remove('mt-accessories__item-description--text');
              itemDesc.el.classList.add(`mt-accessories__item-description--${itemDescType}`);
              itemDesc.el.style.setProperty('--min-height', `${itemHeight}px`);
            }
          }
          updateItemDescription();
          window.addEventListener('resize', updateItemDescription);
          window.addEventListener('touchstart', updateItemDescription);
        });
      }

      // Courses
      if (_this.el.podsSelector.courses && _this.el.podsSelector.coursesItems.length > 0) {
        _this.el.podsSelector.coursesItems.forEach(item => {
          item.addEventListener('click', e => {
            if (item.classList.contains('active')) {
              item.classList.remove('active');
            } else {
              item.classList.add('active');
            }

            const activeProducts = document.querySelectorAll('.mt-courses__item.active').length;
            const choose = _this.el.podsSelector.step.courses.querySelector('.mt-pods-step__choose span');
            if (activeProducts > 0) {
              _this.el.podsSelector.step.courses.classList.add('completed');
              choose.innerHTML = `${activeProducts} ${(activeProducts > 1) ? 'Courses' : 'Course'}`;
            } else {
              _this.el.podsSelector.step.courses.classList.remove('completed');
              choose.innerHTML = '';
            }
            _this.podsSelector.updatePrice();
          });
        });
      }

      // Step controls
      if (_this.el.podsSelector.step.all.length > 0) {
        _this.el.podsSelector.step.all.forEach(step => {
          const summary = step.querySelector('summary');
          summary.addEventListener('click', () => {
            if (step.getAttribute('open') === null) {
              _this.el.podsSelector.step.all.forEach(s => step !== s && s.removeAttribute('open'));
              step.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
            }
          });
        });
      }
      if (_this.el.podsSelector.btn.pods) {
        _this.el.podsSelector.btn.pods.addEventListener('click', e => {
          e.preventDefault();
          _this.el.podsSelector.step.pods.classList.add('completed');
          _this.el.podsSelector.step.pods.removeAttribute('open');
          _this.el.podsSelector.step.memberships.setAttribute('open', '');
          _this.el.podsSelector.step.memberships.removeAttribute('disabled');
          _this.podsSelector.currentStep = 2;
        });
      }
      if (_this.el.podsSelector.btn.memberships) {
        _this.el.podsSelector.btn.memberships.addEventListener('click', e => {
          e.preventDefault();
          _this.el.podsSelector.step.memberships.classList.add('completed');
          _this.el.podsSelector.step.memberships.removeAttribute('open');
          _this.el.podsSelector.step.accessories.setAttribute('open', '');
          _this.el.podsSelector.step.accessories.removeAttribute('disabled');
          _this.el.podsSelector.formBtn.removeAttribute('disabled');
          _this.el.stickyProductFormBtn.removeAttribute('disabled');
          _this.podsSelector.currentStep = 3;
        });
      }

      // Main form
      _this.podsSelector.updatePrice();
      _this.podsSelector.form();
    }
  },

  variantSelector: {
    variants: window.Shopify.productVariants,

    updatePage: function(variant = null) {
      const _this = app.productPage;
      if (variant === null) return;

      // Update product data & ID
      if (_this.el.productFormId) {
        const productData = JSON.parse(_this.el.productFormId.dataset.product);
        productData.variant_id = variant.id;
        productData.variant = variant.title;
        productData.sku = variant.sku;
        productData.price = variant.price / 100;
        _this.el.productFormId.dataset.product = JSON.stringify(productData);
        _this.el.productFormId.value = variant.id;
      }

      // Update price
      let price = variant.price;
      let compareAtPrice = variant.compare_at_price;

      if (variant.bundle_discount) {
        price = Math.round(price * (100 - variant.bundle_discount) / 100);
        compareAtPrice = variant.price;
      }
      
      _this.el.mainPrices.dataset.price = price;
      (compareAtPrice && compareAtPrice > price) ? (_this.el.mainPrices.dataset.compareAtPrice = compareAtPrice) : _this.el.mainPrices.removeAttribute('data-compare-at-price');
      _this.updatePrice();

      // Update ATC
      _this.el.productFormBtn && (_this.el.productFormBtn.dataset.available = variant.available);
      _this.el.stickyProductForm && (_this.el.stickyProductForm.dataset.available = variant.available);

      // Update BIS
      if (_this.el.bisSection && _this.el.bisVariant) {
        _this.el.bisVariant.value = variant.id;
        _this.el.bisSection.classList.toggle('hidden', variant.available);
      }

      (typeof initializePromos == 'function') && initializePromos();
    },

    getCurrentVariant: function() {
      const _this = this;
      const productOptions = app.productPage.el.productForm.querySelectorAll('.mt-product-option__list input');
      if (productOptions && productOptions.length === 0) return;

      const selectedOptions = [...productOptions].filter(o => o.checked).map(o => o.value);
      const variant = _this.variants.find(v => v.options.every(o => selectedOptions.includes(o))) || null;

      if (variant) {
        const discountData = window.Shopify.variantDiscounts;
        if (discountData) {
          variant.bundle_discount = discountData.variants[variant.id] || discountData.product_discount;
        }
      }

      return variant;
    },

    init: function() {
      const _this = this;

      if (app.productPage.el.variantSelector.options.length === 0) return;
    
      app.productPage.el.variantSelector.options.forEach(option => {
        option.addEventListener('change', () => {
          const sameOptions = document.querySelectorAll(`.mt-product input[name="${option.name}"][value="${option.value}"]`);
          (sameOptions.length > 0) && sameOptions.forEach(o => (o.checked = option.checked));
          const currentVariant = _this.getCurrentVariant();
          if (currentVariant !== null) {
            if (history.replaceState) {
              const currentUrl = new URL(window.top.location.href);
              const searchParams = currentUrl.searchParams;
              searchParams.set('variant', currentVariant.id);
              currentUrl.search = searchParams.toString();
              history.replaceState({}, null, currentUrl.toString());
            }
            _this.updatePage(currentVariant);
          }
        });
      });
    }
  },

  sizeGuide: {
    el: {
      switcher: document.querySelector('.mt-modal--size-guide .mt-switcher'),
      table: document.querySelector('.mt-size-guide__table table')
    },

    reCalculate: function(unit = null) {
      const { el } = this;
      if (!el.switcher || !el.table) return;
      (unit === null) && (unit = el.switcher.dataset.active);

      const cells = el.table.querySelectorAll('td');
      cells.forEach(cell => {
        const values = { cm: cell.dataset.cm, inch: cell.dataset.inch };
        if (!values.cm || !values.inch) return;
        cell.innerText = values[unit];
      });
    },

    init: function() {
      const _this = this;
      if (!_this.el.switcher) return;

      _this.el.switcher.addEventListener('click', e => {
        const currentUnit = _this.el.switcher.dataset.active;
        let newUnit = currentUnit;

        if (e.target.classList.contains('mt-switcher__toggle')) {
          newUnit = (currentUnit == 'cm') ? 'inch' : 'cm';
        } else if (e.target.classList.contains('mt-switcher__option')) {
          newUnit = e.target.dataset.option;
        }

        if (currentUnit !== newUnit) {
          _this.el.switcher.dataset.active = newUnit;
          _this.reCalculate(newUnit);
        }
      });
    }
  },

  init: function () {
    const _this = this;
    if (_this.el.section === undefined) return;

    // Update price (if offer)
    _this.updatePrice();

    // Product gallery - sliders
    if (_this.el.thumbs !== undefined) {
      _this.slider.thumbs = new Swiper(_this.el.thumbs, {
        direction: 'vertical',
        slidesPerView: 4,
        spaceBetween: 8,
        height: 504,
        navigation: {
          nextEl: '.mt-product-thumbs__button--next',
          prevEl: '.mt-product-thumbs__button--prev',
        },
        breakpoints: {
          1440: {
            height: 616
          }
        }
      });
    }
    if (_this.el.mainGallery !== undefined) {
      _this.slider.main = new Swiper(_this.el.mainGallery, {
        spaceBetween: 0,
        thumbs: {
          swiper: _this.slider.thumbs
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          450: {
            spaceBetween: -5,
          },
          768: {
            spaceBetween: 5,
          }
        }
      });
    }
    if (_this.el.thumbItems.length > 0) {
      _this.el.thumbItems.forEach(thumb => {
        const index = Number(thumb.dataset.slide);
        thumb.addEventListener('mouseenter', () => _this.slider.main.slideTo(index, 0));
      });
    }
    if (_this.el.thumbButtons.length > 0) {
      _this.el.thumbButtons.forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault();
          (button.classList.contains('mt-product-thumbs__button--prev')) ? _this.slider.thumbs.slidePrev() : _this.slider.thumbs.slideNext();
        });
      });
    }

    // Accordions
    if (_this.el.accordions.length > 0 && _this.el.accordionTabs.length > 0) {
      _this.el.accordions.forEach(accordion => {
        const summary = accordion.querySelector('summary');
        const tab = [..._this.el.accordionTabs].filter(tab => tab.hash == `#${accordion.id}`)[0];
        summary.addEventListener('click', e => {
          e.preventDefault();
          _this.el.accordions.forEach(acc => acc !== accordion && acc.removeAttribute('open'));
          _this.el.accordionTabs.forEach(t => t !== tab && t.classList.remove('active'));
          tab.classList.toggle('active');
          accordion.toggleAttribute('open');
          accordion.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      });
      _this.el.accordionTabs.forEach(tab => {
        const accordion = document.querySelector(tab.hash);
        tab.addEventListener('click', e => {
          e.preventDefault();
          _this.el.accordionTabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');
          _this.el.accordions.forEach(acc => acc.removeAttribute('open'));
          accordion.setAttribute('open', '');
        });
      });
    }

    // Pods selector
    _this.podsSelector.init();

    // Variant selector
    _this.variantSelector.init();

    // Size guide
    _this.sizeGuide.init();

    // Sticky product form
    if (_this.el.productForm && _this.el.stickyProductForm) {
      document.addEventListener('DOMContentLoaded', () => {
        const formButton = _this.el.productForm.querySelector('.mt-btn');
        const pageFooter = document.querySelector('.mt-footer-v2');
        const handleIntersection = () => {
          const buttonRect = formButton.getBoundingClientRect();
          const footerRect = pageFooter.getBoundingClientRect();
          const isButtonVisible = buttonRect.top < window.innerHeight && buttonRect.bottom >= 0;
          const isFooterVisible = footerRect.top < window.innerHeight && footerRect.bottom >= 0;

          _this.el.stickyProductForm.dataset.active = !(isButtonVisible || isFooterVisible);
        };
        window.addEventListener('scroll', handleIntersection);
        handleIntersection();
      });
    }

    // Reviews
    if (_this.el.reviewsSummary) {
      _this.el.reviewsSummary.addEventListener('click', e => {
        e.preventDefault();
        const reviewsSection = document.querySelector('#yotpo-reviews-main-widget');
        reviewsSection && reviewsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    // Events
    const currentProduct = document.querySelector('.mt-product .mt-product-form input[name="id"], .mt-pods__option input:checked');
    if (currentProduct) {
      const viewItemWhenAvailable = () => {
        const viwaId = setInterval(() => {
          if (window.app && window.app.dl && typeof window.app.dl.viewItem === 'function') {
            clearInterval(viwaId);
            window.app.dl.viewItem(currentProduct.dataset.product);
          }
        }, 100);
      };
      viewItemWhenAvailable();
    }

    // Custom CTA
    if (_this.el.title) {
      _this.el.customBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          app.dl.ctaClick(_this.el.title.innerText, { location: 'Course' });
        });
      });
    }
  }
}
window.app.productPage.init();